import { addToast } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { SectionDetail } from '../../../../types/sectionMaintainerTypes';
import { useContinuousEducationFormDataLoader } from '../../loaders/ContinuousEducationLoader';
import { updateContinuousEducationSectionActionRequest } from '../api';
import {
  useContinuousEducationSectionLoader,
  useContinuousEducationSectionLoaderData,
} from '../hooks/ContinuousEducationSectionLoader';
import { ContinuousEducationSectionForm } from './ContinuousEducationSectionForm';

const SectionGeneralTab = () => {
  const { t } = useTranslation();
  const sectionData = useContinuousEducationSectionLoaderData();
  const { refresh } = useContinuousEducationSectionLoader();
  const { result: formDataResult } = useContinuousEducationFormDataLoader();

  const formData = formDataResult?.success ? formDataResult.data : null;

  if (!sectionData || !formData) {
    return null;
  }

  const section = (sectionData.section as unknown) as SectionDetail;

  console.log(section);

  return (
    <div className="mt-2 mx-3">
      <ContinuousEducationSectionForm
        section={section}
        campuses={formData.campuses}
        schedules={formData.schedules}
        deliveryMode={sectionData.section.course.modality?.deliveryMode}
        onSave={async (values) => {
          const {
            data,
            error,
          } = await updateContinuousEducationSectionActionRequest(section.id, {
            name: `${values.code}-${values.name}`,
            maximumStudent: Number(values.quota),
            campusId: Number(values.campus.value),
            scheduleId: Number(values.schedule.value),
            professors: values.teachers.filter((item) => !!item.value),
            assistants: values.assistants.filter((item) => !!item.value),
            onlineAssistanceRequirement: section.onlineAssistanceRequirement,
            assistanceRequirements: section.assistanceRequirements
              ? section.assistanceRequirements.map((r) => ({
                  ...r,
                  minPercentage: Number(r.minPercentage),
                }))
              : [],
          });

          if (data && !error) {
            addToast({
              icon: 'success',
              color: 'success',
              text: t('common.messages.editSuccess'),
            });
            refresh();
          } else {
            addToast({
              icon: 'error',
              color: 'danger',
              text: t('common.errors.save'),
            });
          }
        }}
      />
    </div>
  );
};

export default SectionGeneralTab;
